import { useEffect, useState } from 'react';
import { Collapsible, CollapsibleTrigger } from '@radix-ui/react-collapsible';
import { MenuTitle, MenuType } from '@anytag/router';
import { SidebarGroupContent, SidebarGroup, CollapsibleContent, SidebarMenuSub } from '@anytag/shared-atoms';
import { MenuItem } from './menu-item';

interface MenuGroupProps extends MenuType {
  activeTitle?: MenuTitle;
  disabled?: boolean | null;
}

export const MenuGroup = ({ title, groupTitle, to, href, subMenus: child, activeTitle, disabled }: MenuGroupProps) => {
  const [showChilds, setShowChilds] = useState<boolean>(false);

  const childTitles = child?.map((item) => item?.title) || [];
  const activeIcon = !!activeTitle && [title, ...childTitles].includes(activeTitle);

  useEffect(() => {
    setShowChilds(activeIcon);
  }, [activeIcon]);

  const toggleChildsMenu = () => {
    if (activeTitle === title || !showChilds) {
      setShowChilds((prevState) => !prevState);
    }
  };

  return (
    <Collapsible open={showChilds} onToggle={toggleChildsMenu} className="group/collapsible">
      <SidebarGroup className="p-0">
        <CollapsibleTrigger asChild>
          <MenuItem
            to={to}
            href={href}
            title={title}
            groupTitle={groupTitle}
            activeIcon={activeIcon}
            activeTitle={activeTitle}
            onClick={toggleChildsMenu}
            disabled={disabled}
          />
        </CollapsibleTrigger>
        <CollapsibleContent className="transition-height duration-300">
          <SidebarGroupContent>
            <SidebarMenuSub>
              {child?.map((item, i) => (
                <MenuItem key={i} {...item} hasIcon={false} activeTitle={activeTitle} className="ms-1 pl-1" />
              ))}
            </SidebarMenuSub>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  );
};
